

"use client";

import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { PALETTE } from '@/app/lib/colorPallete';

interface NavLinkProps {
  href: string;
  label: string;
  isActive: boolean;
  activePillId: string;
}

export const NavLink: React.FC<NavLinkProps> = ({ href, label, isActive, activePillId }) => {
  return (
    <Link href={href} className="relative px-3 py-1.5 text-base font-medium transition-colors" style={{ color: PALETTE.darkerGreen }}>
      {label}
      {isActive && (
        <motion.span
          layoutId={activePillId}
          className="absolute inset-0 z-[-1] rounded-full"
          style={{ backgroundColor: `${PALETTE.gold}60` }}
          transition={{ type: 'spring', stiffness: 200, damping: 25 }}
        />
      )}
    </Link>
  );
};